// extracted by mini-css-extract-plugin
module.exports = {"input":"FormRight_input__13m1P","label":"FormRight_label__2G2Vo"};